export var SwapFlowModalButtonTypes;
(function (SwapFlowModalButtonTypes) {
    SwapFlowModalButtonTypes["continue"] = "continue";
})(SwapFlowModalButtonTypes || (SwapFlowModalButtonTypes = {}));
export var SwapFlowModalContentTypes;
(function (SwapFlowModalContentTypes) {
    SwapFlowModalContentTypes["request"] = "request";
    SwapFlowModalContentTypes["terms"] = "terms";
    SwapFlowModalContentTypes["swapCreateSuccess"] = "swapCreateSuccess";
    SwapFlowModalContentTypes["swapCreateError"] = "swapCreateError";
})(SwapFlowModalContentTypes || (SwapFlowModalContentTypes = {}));
